module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "details"
  }, [(_vm.isVisible) ? _c('tooltips', {
    attrs: {
      "tippy": _vm.tooltipsData,
      "box": _vm.tooltipsBox,
      "transparent": true,
      "webgl": true
    }
  }) : _vm._e(), _vm._v(" "), _c('canvas', {
    ref: "canvas",
    staticClass: "details_canvas"
  }), _vm._v(" "), _c('div', {
    staticClass: "room_colors",
    class: {
      active: _vm.roomColorsActive
    }
  }, [_c('button', {
    ref: "room_color_btn",
    staticClass: "room_color_btn rullo visible",
    class: {
      close: _vm.roomColorsActive
    },
    on: {
      "click": function($event) {
        _vm.roomColorsActive = !_vm.roomColorsActive
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/rullo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "room_color_btn_close"
  })]), _vm._v(" "), _vm._l((_vm.colors), function(color) {
    return _c('button', {
      staticClass: "room_color_btn",
      style: ({
        backgroundColor: color
      }),
      on: {
        "click": function($event) {
          _vm.setRoomColor(color)
        }
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "menu bg-lgrey",
    class: {
      visible: _vm.menuIsVisible
    }
  }, [_c('div', {
    staticClass: "menu_title bg-light regular h4 c-dark"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("colors")))]), _vm._v(" "), _c('div', {
    staticClass: "menu_title_tabs",
    class: {
      single: _vm.configurator === 'krossing' || _vm.only_uprights
    }
  }, [_c('button', {
    staticClass: "menu_title_tab h7 medium c-dark",
    class: {
      current: _vm.currentTab === 0
    },
    on: {
      "click": function($event) {
        _vm.changeTab(0)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.configurator === 'krossing' ?
    _vm.$t("uprights") :
    (_vm.only_uprights ?
      _vm.$t("uprights") :
      _vm.$t("element"))) + "\n\t\t\t\t")]), _vm._v(" "), (_vm.configurator !== 'krossing' && !_vm.only_uprights) ? _c('button', {
    staticClass: "menu_title_tab h7 medium c-dark",
    class: {
      current: _vm.currentTab === 1
    },
    on: {
      "click": function($event) {
        _vm.changeTab(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("uprights")) + "\n\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), (_vm.materials) ? _c('div', {
    ref: "colors",
    staticClass: "menu_container"
  }, _vm._l((_vm.materials), function(material, index) {
    return _c('div', {
      staticClass: "menu_element",
      class: {
        selected: _vm.currentMaterialIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectMaterial(material, index)
        }
      }
    }, [_c('div', {
      staticClass: "element_color medium h7",
      class: {
        glossy: material.glossy
      },
      style: ({
        background: material.css_color,
        color: material.txt_color
      })
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t(material.key)[0]) + "\n\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "h7 regular d-dark"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t(material.key)) + "\n\t\t\t\t")])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [(_vm.configurator !== 'krossing' && !_vm.only_uprights) ? _c('button', {
    staticClass: "bg-lgrey c-dark h7 regular upcase",
    on: {
      "click": _vm.applyToAll
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("apply")) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.configurator === 'krossing' || _vm.only_uprights) ? _c('button', {
    staticClass: "bg-lgrey c-dark h7 regular upcase",
    on: {
      "click": _vm.finishEditing
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("close")) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "bg-accent c-light h7 regular upcase",
    on: {
      "click": _vm.finishEditing
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t("confirm")) + "\n\t\t\t")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fe9702e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/views/Details.vue
// module id = 655
// module chunks = 0